import CardDonneurOrdre from "../CardDonneurOrdre";
export default function SectionListeDonneursOrdres({total, listDonneursOrdres, title }) {

    
    return (
        <section className="section-list-presta">
            <h2 className="gold-text">INTERESEAUX</h2>
            <h3 style={{textAlign:"center",fontSize:"1.6em"}}>{title}</h3>
            <div className="list-presta-container">
                {
                    listDonneursOrdres.map((donneurOrdre)=>(

                        
                        <CardDonneurOrdre key={donneurOrdre.idProfilDonneurOrdre} donneurOrdre={donneurOrdre}/>
                        
                    )

                    )
                }
            </div>
        </section>
    )

}